import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyEn = () => {
  return (
    <div className="container py-4">
      <h1>Tzone Privacy Policy</h1>
      <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>

      <h2>1. Who we are</h2>
      <p>
        Tzone is a platform for planning, tracking and analysing sports training, operated by{' '}
        <strong>TZONE Corp SpA</strong>, tax ID <strong>77923319-7</strong>, based in
        Lo Barnechea, Santiago de Chile (hereinafter, “<strong>Tzone</strong>”, “we” or “us”).
      </p>
      <p>
        If you have any questions about this policy or about how we process your personal data,
        please contact us at: <a href="mailto:contacto@tzone.run">contacto@tzone.run</a>.
      </p>

      <h2>2. Scope</h2>
      <p>
        This Privacy Policy applies to the use of the Tzone platform, the website{' '}
        <strong>tzone.run</strong> and any related applications, including integrations with
        third-party services such as Garmin Connect or other activity tracking providers.
      </p>

      <h2>3. Data we process</h2>
      <p>Depending on how you use Tzone, we may process the following categories of data:</p>
      <ul>
        <li>
          <strong>Account data:</strong> name, surname, email address, country, language,
          user type (athlete/coach) and encrypted login credentials.
        </li>
        <li>
          <strong>Sports profile data:</strong> date of birth, sex, height, weight, physiological
          thresholds, training zones and other information used to personalise analysis.
        </li>
        <li>
          <strong>Training data:</strong> planned and completed sessions, effort metrics
          (e.g. duration, heart rate, power, pace, TSS, etc.), comments from the athlete or
          coach, and technical files such as FIT, TCX or similar formats.
        </li>
        <li>
          <strong>Data from third parties:</strong> when you connect Tzone to external services
          (for example Garmin Connect), we receive the data that you explicitly authorise to be
          shared from those services.
        </li>
        <li>
          <strong>Technical data:</strong> device identifiers, security logs, approximate IP
          address, browser and basic usage information about how you interact with the platform.
        </li>
      </ul>

      <h2>4. Purposes</h2>
      <p>We use your data in order to:</p>
      <ul>
        <li>Create and manage your Tzone user account.</li>
        <li>
          Synchronise, store and display your training data so that you and, where applicable,
          your coach can plan, track and analyse your performance.
        </li>
        <li>
          Compute derived metrics (for example training load, fatigue and fitness indicators)
          based on your activities.
        </li>
        <li>
          Send notifications related to your training, reminders or schedule changes, where such
          notifications are enabled in your account.
        </li>
        <li>
          Keep the platform secure, prevent misuse and comply with legal or regulatory
          obligations.
        </li>
        <li>
          Improve the service and develop new features, using anonymised or aggregated data
          whenever possible.
        </li>
      </ul>

      <h2>5. Legal bases</h2>
      <p>Depending on the specific processing, we rely on the following legal bases:</p>
      <ul>
        <li>
          <strong>Performance of a contract:</strong> when we process your data in order to
          provide the Tzone service in accordance with the Terms of Use you accept.
        </li>
        <li>
          <strong>Consent:</strong> when you connect third-party services (e.g. Garmin Connect)
          and explicitly authorise the exchange of data.
        </li>
        <li>
          <strong>Legitimate interest:</strong> to maintain platform security, prevent fraud and
          improve the user experience, provided that your rights and freedoms are not overridden.
        </li>
        <li>
          <strong>Legal obligations:</strong> where applicable law requires us to retain or share
          certain data.
        </li>
      </ul>

      <h2>6. Data sharing and recipients</h2>
      <p>
        Tzone does not sell your personal data. We only share it with third parties in the
        following situations:
      </p>
      <ul>
        <li>
          <strong>Technical providers:</strong> hosting, database, email and analytics services
          that help us operate the platform.
        </li>
        <li>
          <strong>Sports integrations:</strong> services such as Garmin Connect or others, only
          when you enable the integration and under your explicit authorisation.
        </li>
        <li>
          <strong>Coaches and clubs:</strong> when you choose to link your account to a coach or
          club, they will be able to view the information necessary to plan and monitor your
          training.
        </li>
        <li>
          <strong>Authorities or legally entitled third parties:</strong> where we are required
          to do so by law or by a competent authority.
        </li>
      </ul>

      <h2>7. International transfers</h2>
      <p>
        Some of our service providers may be located outside Chile or operate from multiple
        jurisdictions. In such cases we require them to apply appropriate safeguards for data
        protection (for example contractual clauses, recognised security standards and data
        pseudonymisation or encryption).
      </p>

      <h2>8. Retention</h2>
      <p>
        We keep your data for as long as your account remains active and for an additional
        period that is reasonably necessary to handle potential claims or legal requirements.
        You may request deletion of your account at any time; in that case we will delete or
        anonymise your data to the extent permitted by applicable law.
      </p>

      <h2>9. Your rights</h2>
      <p>You may have the following rights under applicable data protection law:</p>
      <ul>
        <li>Right of access to your personal data.</li>
        <li>Right to rectify inaccurate or incomplete data.</li>
        <li>Right to erasure or blocking of data where appropriate.</li>
        <li>Right to object to or restrict certain types of processing.</li>
        <li>
          Right to data portability for information you have provided to us, where technically
          feasible.
        </li>
      </ul>
      <p>
        To exercise these rights, please contact us at{' '}
        <a href="mailto:contacto@tzone.run">contacto@tzone.run</a> and include your full name,
        the right you wish to exercise and any information needed to locate your account.
      </p>

      <h2>10. Security</h2>
      <p>
        We implement reasonable technical and organisational measures to protect your data from
        unauthorised access, loss, destruction or alteration. However, no system is entirely
        infallible, so it is important that you also keep your login credentials secure and
        notify us immediately of any unauthorised use of your account.
      </p>

      <h2>11. Changes to this policy</h2>
      <p>
        We may update this Privacy Policy when necessary to reflect changes in the platform, in
        our processing activities or in applicable law. We will always publish the current
        version at <strong>tzone.run</strong> and indicate the date of the latest update. For
        material changes, we may also notify you by email or within the application.
      </p>
	  
      {/* 🔙 Botón para volver al Home */}
      <div className="mt-4">
        <Link to="/home" className="btn btn-outline-primary btn-sm">
          Volver al inicio
        </Link>
      </div>
    </div>
  );
};

export default PrivacyEn;
